<template>
  <div id="roles">
    <div class="main">
      <div class="search_expand_area">
        <el-button type="text" @click="toggleSearchForm">
          {{$t('cmsg.search')}}
          <i class="el-icon-arrow-right el-icon--right"></i>
        </el-button>
      </div>
      <el-form
        :inline="true"
        :model="searchForm"
        size="mini"
        class="search_form"
        status-icon
        :validate-on-rule-change="false"
        :show-message="false"
      >
        <el-form-item :label="$t('cmsg.name')">
          <el-input v-model="searchForm.name"></el-input>
        </el-form-item>
        <el-form-item>
          <el-button
            type="default"
            @click="searchSubmit"
            :disabled="tableLoading"
            :loading="tableLoading"
            icon="el-icon-3d-search"
          >{{$t('cmsg.search')}}</el-button>
          <el-button
            type="default"
            @click="onSearchReset"
            icon="el-icon-3d-reset"
          >{{$t('cmsg.reset')}}</el-button>
          <el-button
            v-if="perms.indexOf('role.add_role') > -1"
            @click="onNew"
            type="primary"
          >{{$t('cmsg.new')}}</el-button>
        </el-form-item>
      </el-form>
      <el-table :data="items" stripe style="width: 100%">
        <el-table-column :label="$t('cmsg.name')">
          <template slot-scope="scope">
            <div>{{scope.row.Name}}[{{scope.row.UniqueName}}]</div>
          </template>
        </el-table-column>
        <el-table-column prop="Perms" :label="$t('cmsg.perm')">
          <template slot-scope="scope">
            <el-popover
              trigger="hover"
              placement="bottom"
              v-if="scope.row.Perms !== ''"
              width="250"
            >
              <s-table :tableData="extractPerm(scope.row.Perms)" :title="$t('cmsg.seePerms')" />
              <div slot="reference" class="name-wrapper">
                <el-tag size="medium">{{$t('cmsg.seePerms')}}</el-tag>
              </div>
            </el-popover>
          </template>
        </el-table-column>
        <el-table-column :label="$t('cmsg.action')" width="320">
          <template slot-scope="scope">
            <el-button
              type="default"
              class="case_btn"
              size="mini"
              v-if="perms.indexOf('role.set_role_perm')>-1 && scope.row.UniqueName !== 'super_admin'"
              @click="setPerm(scope.row)"
            >{{$t('cmsg.setPerm')}}</el-button>
            <el-button
              type="default"
              class="case_btn"
              size="mini"
              v-if="perms.indexOf('role.delete_role')>-1 && scope.row.UniqueName !== 'super_admin'"
              @click="del(scope.row)"
            >{{$t('cmsg.delete')}}</el-button>
          </template>
        </el-table-column>
      </el-table>
      <br />
      <el-pagination
        background
        @size-change="handleSizeChange"
        @current-change="handleCurrentChange"
        :current-page="pageInfo.page"
        :page-sizes="[5, 10, 50, 100, 200, 300, 400]"
        :page-size="pageInfo.pageSize"
        :page-count="pageInfo.pages"
        layout="prev, pager, next, total, sizes"
        :total="pageInfo.total"
      ></el-pagination>
      <el-dialog
        :title="$t('cmsg.newRole')"
        :visible.sync="nr.visible"
        :close-on-click-modal="nr.modelClose"
        :close-on-press-escape="nr.modelClose"
      >
        <el-form :model="nr.editData" size="mini" ref="nRole">
          <el-form-item :label="$t('cmsg.name')" prop="name" required>
            <el-input v-model="nr.editData.name" :placeholder="$t('cmsg.name')" />
          </el-form-item>
          <el-form-item prop="uniqueName" :label="$t('cmsg.uniqueName')" required>
            <el-input
              v-model="nr.editData.uniqueName"
              size="medium"
              :placeholder="$t('cmsg.uniqueName')"
            />
          </el-form-item>
          <el-form-item prop="isBack" :label="$t('cmsg.isAdmin')">
            <el-radio-group v-model="nr.editData.isBack">
              <el-radio-button label="y">{{$t('cmsg.yes')}}</el-radio-button>
              <el-radio-button label="n">{{$t('cmsg.no')}}</el-radio-button>
            </el-radio-group>
          </el-form-item>
        </el-form>
        <div slot="footer" class="dialog-footer">
          <el-button @click="closeNRDialog">{{$t('cmsg.cancel')}}</el-button>
          <el-button type="primary" @click="submitNR" :loading="nr.loading">{{$t('cmsg.submit')}}</el-button>
        </div>
      </el-dialog>
      <el-dialog
        :title="$t('cmsg.setPerm')"
        :close-on-click-modal="sr.modelClose"
        :close-on-press-escape="sr.modelClose"
        :visible.sync="sr.visible"
        width="80%"
        center
      >
        <el-form size="mini" ref="setRole">
          <p>{{$t('cmsg.setRolePermHint',{ name: sr.Name })}}</p>
          <el-form-item>
            <el-transfer
              filterable
              :titles="[$t('cmsg.source'), $t('cmsg.target')]"
              :filter-method="transferFilter"
              :filter-placeholder="$t('cmsg.permName')"
              v-model="sr.permData.perms"
              class="transfer"
              :data="sr.pData"
            ></el-transfer>
          </el-form-item>
        </el-form>
        <div slot="footer">
          <el-button @click="closeSRDialog">{{$t('cmsg.cancel')}}</el-button>
          <el-button
            @click="submitSR"
            :disabled="sr.permData.tid === ''"
            :loading="sr.loading"
            type="primary"
          >{{$t('cmsg.submit')}}</el-button>
        </div>
      </el-dialog>
    </div>
  </div>
</template>
<script>
import Cookies from "js-cookie";
import sTable from "@/views/user/component/sTable";
export default {
  components: { sTable },
  data() {
    return {
      searchForm: {
        name: ""
      },
      nr: {
        visible: false,
        loading: false,
        modelClose: false,
        editData: {
          name: "",
          uniqueName: "",
          isBack: "y"
        }
      },
      sr: {
        modelClose: false,
        visible: false,
        loading: false,
        permData: {
          tid: "",
          perms: []
        },
        pData: [],
        Name: ""
      }
    };
  },
  methods: {
    submitSR() {
      if (this.sr.permData.tid !== "") {
        this.sr.loading = true;

        this.$axios
          .post("/api/u/auth/role/srp", this.sr.permData, {
            json: true,
            validateStatus: function(status) {
              return status >= 200 && status < 404; // default
            }
          })
          .then(res => {
            if (res.data.status === "success") {
              this.$message({
                type: "success",
                message: this.$t("cmsg.setRolePermHintSuccess", {
                  name: this.sr.Name
                })
              });
              this.closeSRDialog();
              var t = this;
              setTimeout(function() {
                window.location = t.$router.resolve({
                  name: "roles",
                  query: t.$route.query
                }).href;
              }, 3000);
            }
            this.sr.loading = false;
          })
          .catch(res => (this.sr.loading = false));
      }
    },
    setPerm(row) {
      console.log(row);
      this.sr.permData.tid = row.Id;
      this.sr.Name = row.Name;
      this.$axios
        .get(`/api/u/auth/perm/list`, {
          params: { pageSize: 1000000 },
          json: true,
          validateStatus: function(status) {
            return status >= 200 && status < 404; // default
          }
        })
        .then(res => {
          console.log(res);
          this.sr.pData = res.data.result.map(obj => {
            var label = null;
            if (this.$gf.lang() === "cn") {
              label = obj.NameCN;
            } else {
              label = obj.Name;
            }
            return {
              key: obj.Id,
              label
            };
          });
        });

      if (row.Perms !== "") {
        try {
          let perms = JSON.parse(row.Perms);
          console.log(perms);
          this.sr.permData.perms = perms.map(item => {
            console.log(item);
            return item.id;
          });
        } catch (e) {
          console.warn("perm convert error");
        }
      }
      this.sr.visible = true;
    },
    closeSRDialog() {
      this.sr = {
        modelClose: false,
        visible: false,
        loading: false,
        permData: {
          tid: "",
          perms: []
        },
        pData: [],
        Name: ""
      };
    },
    transferFilter(query, item) {
      return item.label.indexOf(query) !== -1;
    },
    del(row) {
      this.$confirm(
        this.$t("cmsg.delRole", { name: row.Name }),
        this.$t("cmsg.delRoleHint"),
        {
          confirmButtonText: this.$t("cmsg.sure"),
          cancelButtonText: this.$t("cmsg.cancel"),
          type: "warning"
        }
      ).then(() => {
        this.$axios
          .post(`/api/u/auth/role/del?tid[]=${row.Id}`, {
            json: true,
            validateStatus: function(status) {
              return status >= 200 && status < 404; // default
            }
          })
          .then(res => {
            if (res.data.status === "success") {
              this.$message({
                type: "success",
                message: this.$t("cmsg.delRoleHintSuccess", { name: row.Name })
              });
              var t = this;
              setTimeout(function() {
                window.location = t.$router.resolve({
                  name: "roles",
                  query: t.$route.query
                }).href;
              }, 3000);
            }
          });
      });
    },
    submitNR() {
      this.nr.loading = true;
      this.$refs.nRole.validate(valid => {
        if (valid) {
          this.$axios
            .post("/api/u/auth/role/add", this.nr.editData, {
              json: true,
              validateStatus: function(status) {
                return status >= 200 && status < 404; // default
              }
            })
            .then(res => {
              if (res.data.status == "success") {
                this.$message({
                  type: "success",
                  message: this.$t("cmsg.addRoleSuccess")
                });

                this.nr.visible = false;
                this.closeNRDialog();
              }

              this.nr.loading = false;
              var t = this;
              setTimeout(function() {
                window.location = t.$router.resolve({
                  name: "roles",
                  query: t.$route.query
                }).href;
              }, 3000);
            })
            .catch(res => (this.nr.loading = false));
        } else {
          this.nr.loading = false;
          return false;
        }
      });
    },
    closeNRDialog() {
      this.nr = {
        visible: false,
        loading: false,
        modelClose: false,
        editData: {
          name: "",
          uniqueName: "",
          isBack: "y"
        }
      };
    },
    onNew() {
      this.nr = {
        visible: true,
        loading: false,
        modelClose: false,
        editData: {
          name: "",
          uniqueName: "",
          isBack: "y"
        }
      };
    },
    extractPerm(perms) {
      try {
        let permJson = JSON.parse(perms);

        return permJson.map(item => item.name);
      } catch (e) {
        console.warn("extract perm error");
        console.warn(e);
      }
      return [];
    },
    toggleSearchForm() {
      var el = document.querySelector(".search_form");
      var elBtn = document.querySelector(".search_expand_area .el-icon--right");
      // console.log();
      if (el.style.display === "" || el.style.display === "none") {
        el.style.display = "block";
        elBtn.classList.remove("el-icon-arrow-right");
        elBtn.classList.add("el-icon-arrow-down");
      } else {
        el.style.display = "none";
        elBtn.classList.remove("el-icon-arrow-down");
        elBtn.classList.add("el-icon-arrow-right");
      }
    },
    onSearchReset() {
      console.log(this.$route.query);
      this.searchForm = {
        name: ""
      };
    },
    initSearch() {
      var queryObj = this.$route.query;
      if (queryObj["name"]) {
        this.searchForm.name = queryObj["name"];
      }
    },
    searchSubmit() {
      console.log(this.searchForm);
      var queryObj = this.$route.query;
      queryObj["name"] = this.searchForm.name;
      queryObj["page"] = 1;
      console.log(queryObj);
      Object.keys(queryObj).map((k, i) => {
        if (
          queryObj[k] === undefined ||
          queryObj[k] === "" ||
          (k === "page" && queryObj[k] === 1)
        ) {
          delete queryObj[k];
        }
      });
      console.log(queryObj);
      window.location = this.$router.resolve({
        name: "roles",
        query: queryObj
      }).href;
    },
    handleSizeChange(val) {
      console.log(val);
      var queryObj = this.$route.query;
      queryObj["pageSize"] = val;
      queryObj["page"] = 1;
      window.location = this.$router.resolve({
        name: "roles",
        query: queryObj
      }).href;
      // this.$redirect({name:'cases',query: queryObj});
    },
    handleCurrentChange(val) {
      console.log(val);
      var queryObj = this.$route.query;
      queryObj["page"] = val;
      window.location = this.$router.resolve({
        name: "roles",
        query: queryObj
      }).href;
      // this.$redirect({name:'cases',query: queryObj});
    }
  },
  mounted() {
    // console.log("this.perms: ", this.$store.state.perms);
    // console.log("this.$perms: ", this.$perms);
    this.initSearch();
    // this.setPerm();
    console.log("this.perms: ", this.perms);
    console.log("mounted:", pub.cdnUrl);
  },
  metaInfo() {
    return {
      title:
        this.$gf.sysParam(this.$gf.lang(), "title") +
        "-" +
        this.$t("cmsg.roles")
    };
  },
  async asyncData(context) {
    let pageInfo = { page: 0, pageSize: 50, pages: 0, total: 0 };
    let items = [];
    let perms = [];
    var activeIndex = "all";
    if (context.req && context.req.query && context.req.query.status) {
      activeIndex = context.req.query.status;
    }
    await context.$axios
      .get("/api/u/auth/role/list", {
        json: true,
        params: context.route.query,
        validateStatus: function(status) {
          return status >= 200 && status < 404; // default
        }
      })
      .then(res => {
        // console.log(res)
        // var items = [];
        if (res.data.result && Array.isArray(res.data.result)) {
          items = res.data.result;
          pageInfo = res.data.pageInfo;
        }
      })
      .catch(e => {
        console.log(e);
      });
    await context.$axios
      .get(`/api/u/settings/b/up`, {
        json: true,
        validateStatus: function(status) {
          return status >= 200 && status < 404; // default
        }
      })
      .then(res => {
        // console.log(res);
        if (
          res.status === 200 &&
          res.data &&
          res.data.status === "success" &&
          res.data.result !== null
        ) {
          perms = res.data.result;
        }
      })
      .catch(e => {
        console.log(e);
      });
    // console.log("perms: ",perms);
    return {
      pageInfo: pageInfo,
      items: items,
      perms: perms,
      tableLoading: false,
      activeIndex: activeIndex
    };
  }
};
</script>
<style lang="scss">
.fileDownPopover {
  .el-button {
    display: block;
    margin-left: 0px;
  }
}
#roles {
  .main {
    background-color: #f7f9fb;
    padding: 15px;
    text-align: left;
    .case_nav {
      display: flex;
      overflow: auto;
    }
    .el-menu-item {
      display: inline;
      border-top: 1px solid #e6e6e6;
      border-left: 1px solid #e6e6e6;
    }
    .el-menu-item.is-active {
      background-color: #f3f3f3;
    }
    .el-menu-item:last-of-type {
      border-right: 1px solid #e6e6e6;
    }
    .hidden_delivery {
      display: none;
    }
    .large_preview {
      width: 80%;
    }
    .large_preview .el-message-box__content {
      overflow: auto;
    }
    .el-table__expanded-cell[class*="cell"] {
      padding: 0px 0px 15px 0px;
    }
    .el-tabs--card > .el-tabs__header .el-tabs__nav {
      border-top-width: 0px;
    }
    .case_btn {
      margin-right: 5px;
      margin-bottom: 5px;
      margin-left: 0px !important;
    }
    .search_expand_area {
      display: none;
    }
    .search_form {
      display: block;
    }
    @media screen and (min-width: 1020px) {
      .search_expand_area {
        display: none;
      }
      .search_form {
        display: block;
      }
    }
    .el-table__expanded-cell[class*="cell"] {
      padding-bottom: 0px !important;
    }
    @media screen and (max-width: 1020px) {
      .search_expand_area {
        display: block;
      }
      .search_form {
        display: none;
      }
      .el-menu-item [class^="el-icon-"] {
        margin-right: 0px;
      }
      .el-menu-item:not(.is-active) .dp_title {
        display: none;
        /* display: inline; */
      }
      .is-active .dp_title {
        display: inline;
      }
      .el-menu-item {
        padding: 0 0px 0 5px;
      }
      .el-pager li:not(.active) {
        display: none;
      }
    }
  }
}
</style>
